import { Link } from "react-router-dom";
import { useState } from "react";
import { useDataSaver } from "@/context/DataSaverContext";
import VoteButton from "@/components/VoteButton";

export default function CandidateCard({ candidate, rank, index = 0 }) {
  const { dataSaver } = useDataSaver();
  const [votes, setVotes] = useState(candidate.votes);

  return (
    <div
      className="card-lux group relative flex flex-col"
      data-testid={`candidate-card-${candidate.slug}`}
      style={{ animationDelay: `${Math.min(index * 60, 480)}ms` }}
    >
      <Link to={`/candidates/${candidate.slug}`} className="relative block overflow-hidden">
        <div className="aspect-[3/4] bg-obsidian-600">
          <img
            src={candidate.portrait_url}
            alt={`${candidate.name} — ${candidate.delegation_name}`}
            loading={dataSaver ? "lazy" : index < 4 ? "eager" : "lazy"}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/10 to-transparent" />
        {rank && (
          <span className="absolute left-3 top-3 gold-bg text-obsidian font-mono font-bold text-xs px-2.5 py-1 rounded-full">
            #{rank}
          </span>
        )}
        <span className="absolute right-3 top-3 text-2xl drop-shadow-lg" title={candidate.delegation_name}>
          {candidate.flag}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-4">
          <p className="kicker mb-1">{candidate.delegation_name}</p>
          <h3 className="font-serif text-xl text-amber-50 leading-tight">{candidate.name}</h3>
        </div>
      </Link>
      <div className="flex items-center justify-between gap-2 p-4 pt-3">
        <div>
          <p className="font-mono text-lg gold-text tabular-nums" data-testid={`candidate-votes-${candidate.slug}`}>
            {votes.toLocaleString()}
          </p>
          <p className="text-[0.65rem] uppercase tracking-wider text-muted-foreground">votes</p>
        </div>
        <VoteButton candidate={candidate} size="sm" label="Vote" onVoted={setVotes} />
      </div>
    </div>
  );
}
